<template>
  <div class="sencebg">
    <!-- <img src="../static/sence.jpg" class="bg"  alt=""> -->
    <div class="sence" id="sencebg">
      <p :class="music ? 'music zhuan' : 'music'" @click="stopmusic"></p>
      <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
      <img src="../static/title.png" class="title" alt="">
      <!-- <img src="../static/toright.gif" class="toright" alt=""> -->
      <div class="tips">
        <img src="../static/icon1.png" class="icon1" alt="">
        <p class="words">上下左右滑动</p>
        <p class="words">逛古城，看精彩</p>
      </div>
      <div class="describe" @click="describe = true">活动说明</div>

      <div class="describe-box" v-show="describe" @click="describe = false">
        <van-icon name="close" class="close" />
        <div class="box">
          <p>
            此次“爱金华，逛古城”婺州古城春节系列活动，以丰富的传统文化为底色，以春节和元宵为主线，策划了以“婺风”为主题特色的多元活动。活动以互动性和沉浸感为核心，融入婺州元素和蛇年主题，打造充满年味与文化韵味的节庆体验，全方位展示婺州古城独特的历史底蕴与城市魅力，促进文旅融合发展迈向新高度。
          </p>
          <p>穿梭其间，你可以与财神互动祈福、徜徉诗词盛会，感受宋韵之美。一城一景，一步一趣，在烟火与人情交融的欢腾中，尽揽婺州的年味与底蕴。</p>
          <p>您可以滑动屏幕，浏览古城地图，通过观察不一样的地标，点击查看该地区举办的活动，来了解不一样的风土人情。</p>
        </div>
      </div>

      <div class="day-box" v-show="theday">
        <van-icon name="close" class="close" @click="theday = false" />
        <div class="theday-box">
          <div class="theday">
            <p class="thetitle">{{thetitle}}</p>
            <p class="time">时间：{{time}}</p>
            <p class="address">地点：{{address}}</p>
            <p class="address">活动内容：</p>
            <p class="introduce">
              {{ introduce }}
            </p>
            <img :src="theimg" class="theimg" alt="">
          </div>
        </div>

      </div>

      <img src="../static/d1.png" class="d1" @click="showdaybox(1)" alt="">
      <img src="../static/d2.png" class="d2" @click="showdaybox(2)" alt="">
      <img src="../static/d3.png" class="d3" @click="showdaybox(3)" alt="">
      <img src="../static/d4.png" class="d4" @click="showdaybox(4)" alt="">
      <img src="../static/d5.png" class="d5" @click="showdaybox(5)" alt="">
      <img src="../static/d6.png" class="d6" @click="showdaybox(6)" alt="">
      <img src="../static/d7.png" class="d7" @click="showdaybox(7)" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      describe: false,
      theday: false,
      music: true,
      thetitle:'祈“年福”',
      time:'初一',
      address:'文庙',
      introduce:'官员带领着官兵与小厮从侍王府出发，一路巡游至熙春巷饼街舞台，张贴开城门、开庙布告，预报开城门和开庙时间。随后带队巡游至保宁门前举行开城门仪式。开城门结束后带队巡游至文庙，举行开庙仪式。由鸣赞指引，打开庙门，引领游客在大成殿前祈福，拜先贤先儒。',
      theimg:require("../static/d1.jpg"),
    }
  },
  methods: {
    showdaybox(a) {
      if(a==1){
        this.thetitle='祈“年福”'
        this.time='初一'
        this.address='文庙'
        this.introduce='官员带领着官兵与小厮从侍王府出发，一路巡游至熙春巷饼街舞台，张贴开城门、开庙布告，预报开城门和开庙时间。随后带队巡游至保宁门前举行开城门仪式。开城门结束后带队巡游至文庙，举行开庙仪式。由鸣赞指引，打开庙门，引领游客在大成殿前祈福，拜先贤先儒。',
      this.theimg=require("../static/d1.jpg")
      }else if(a==2){
        this.thetitle='品“非遗”'
        this.time='初二'
        this.address='点将台'
        this.introduce='多部婺剧演出，将这一传统艺术展示给游客。在这里，台上台下，戏里戏外，皆是人生。当我们开始懂得欣赏，就已是戏中人。'
        this.theimg=require("../static/d2.jpg")
      }else if(a==3){
        this.thetitle='当“学霸”'
        this.time='初三'
        this.address='文庙南广场'
        this.introduce='在文庙大成门前开展“诗词问答”专题活动，主持人邀请游客加入互动，完成问答活动可以获取精美纪念品，小朋友可头戴状元帽拍照留念。'
        this.theimg=require("../static/d3.jpg")
      }else if(a==4){
        this.thetitle='追“情缘”'
        this.time='初四'
        this.address='保宁门'
        this.introduce='城墙设计抛绣球，一起领略宋制婚礼的庄重，新人巡游古城发伴手礼，现场大型交友活动。为年轻人过年催婚热潮降降温。'
        this.theimg=require("../static/d4.jpg")
      }else if(a==5){
        this.thetitle='迎“财神”'
        this.time='初五'
        this.address='八咏楼（实际全城）'
        this.introduce='在正月初五这一天，民间又称“破五”，人们会迎财神，借助这一典故，将举办财神巡游活动。走财道、沾财气……演员扮演福禄寿等财神造型，数十人全员打扮成可爱风格的小财神，一同在古城内巡游，互动性强。路线贯穿整个古城，NPC身着财神造型，手捧巨型定制金元宝，巡游过程与游客和商户进行互动，象征财神走进千万家，一路互动拍照，增加新年趣味。'
        this.theimg=require("../static/d5.jpg")
      }else if(a==6){
        this.thetitle='逛“庙会”'
        this.time='初六'
        this.address='万佛塔公园'
        this.introduce='婺州东市春节庙会。有大篷车表演区，鱼灯区，年货市集区，小吃区和游玩区等庙会主题区。'
        this.theimg=require("../static/d6.jpg")
      }else if(a==7){
        this.thetitle='赏“金音”'
        this.time='初七'
        this.address='黄宾虹小广场'
        this.introduce='着国风汉服，共赴一场国乐盛典。展现中国传统乐器对新年的庆祝表达，乐手们通过独奏和合奏的表演形式为古城增添一份浓厚的新春氛围，用悠扬的音乐迎接蛇年的到来。'
        this.theimg=require("../static/d7.jpg")
      }
      this.theday = true
    },
    stopmusic() {
      let audio = document.getElementById("audio");
      if (this.music == true) {
        this.music = false;
        audio.pause();
      } else {
        this.music = true;
        audio.volume = 0.2

        audio.play();
      }
    },
    androidplay() {
      if (navigator.userAgent.indexOf("Android") > 0) {
        //如果是Android的话，在判断是否是微信端打开链接
        function is_weixn() {
          var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
          } else {
            return false;
          }
        }
        //如果是在Android端微信打开 触摸播放
        if (is_weixn()) {
          document.addEventListener('touchstart', () => {

            if (this.music) {
              this.start = false
              document.getElementById('audio').volume = 0.2;
              document.getElementById('audio').play();
            }


          })
        } else {
        }
      }
    },

    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // console.log("header 滚动距离 ", scrollTop);
      if (scrollTop > 0 && !this.mp4) {
        if (this.music) {
          this.start = false
          document.getElementById('audio').volume = 0.2
          document.getElementById('audio').play();
        }
      }

      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;

      //变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
        console.log("header  你已经到底部了");
      }
      //   if (scrollStep < 0) {
      //     console.log("header 滚动条向上滚动了！");
      //   } else {
      //     console.log("header  滚动条向下滚动了！");
      //   }
      // 判断是否到了最顶部
      if (scrollTop <= 0) {
        console.log("header 到了最顶部")
      }
    }
  },
  mounted() {
    const bg = document.getElementById("sencebg");
    bg.style.width = window.innerHeight / 4022 * 6143 * 1.5 + "px"
    bg.style.setProperty("--beilv", window.innerHeight / 667 / (window.innerWidth / 375));
    window.addEventListener("scroll", this.scrolling)
    this.androidplay()
    window.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {


      document.getElementById('audio').volume = 0.2;
      document.getElementById('audio').play();
      document.removeEventListener('WeixinJSBridgeReady', onBridgeReady);

    }, false)
  },
}
</script>

<style lang="less">
.sencebg {
  width: 100%;
  height: 100%;
  position: relative;
  //   overflow-y: hidden;
  overflow: auto;

  .sence {
    position: relative;
    background: url("../static/bg.jpg");
    background-size: 100% 100%;
    height: 150vh;

    .music {
      position: fixed;
      width: 40px;
      height: 40px;
      top: 35px;
      right: 20px;
      background: url("../static/music.png") center no-repeat;
      background-size: 100% 100%;
      z-index: 3;

      &.zhuan {
        animation: turn 2s linear infinite;

        @keyframes turn {
          0% {
            -webkit-transform: rotate(0deg);
          }

          25% {
            -webkit-transform: rotate(90deg);
          }

          50% {
            -webkit-transform: rotate(180deg);
          }

          75% {
            -webkit-transform: rotate(270deg);
          }

          100% {
            -webkit-transform: rotate(360deg);
          }
        }
      }
    }

    .title {
      position: fixed;
      width: calc(200px*var(--beilv));
      left: 50%;
      margin-left: calc(-100px*var(--beilv));
      top: calc(25px*var(--beilv));
      ;
      z-index: 2;
    }

    .toright {
      position: absolute;
      width: calc(160px*var(--beilv));
      left: calc(80px*var(--beilv));
      bottom: calc(5px*var(--beilv));
    }

    .d1 {
      position: absolute;
      width: calc(67px*var(--beilv));
      top: calc(687px*var(--beilv));
      left: calc(570px*var(--beilv));
      animation: d1-ani 2s linear infinite;

      @keyframes d1-ani {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.2);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .d2 {
      position: absolute;
      width: calc(67px*var(--beilv));
      top: calc(574.5px*var(--beilv));
      left: calc(630px*var(--beilv));
      animation: d2-ani 2s linear infinite;

      @keyframes d2-ani {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.2);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .d3 {

      position: absolute;
      width: calc(67px*var(--beilv));
      top: calc(742px*var(--beilv));
      left: calc(555px*var(--beilv));
      animation: d3-ani 2s linear infinite;

      @keyframes d3-ani {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.2);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .d4 {
      position: absolute;
      width: calc(67px*var(--beilv));
      top: calc(769px*var(--beilv));
      left: calc(830px*var(--beilv));
      animation: d4-ani 2s linear infinite;

      @keyframes d4-ani {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.2);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .d5 {
      position: absolute;
      width: calc(67px*var(--beilv));
      top: calc(828px*var(--beilv));
      left: calc(515px*var(--beilv));
      animation: d5-ani 2s linear infinite;

      @keyframes d5-ani {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.2);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .d6 {
      position: absolute;
      width: calc(67px*var(--beilv));
      top: calc(420px*var(--beilv));
      left: calc(1225px*var(--beilv));
      animation: d6-ani 2s linear infinite;

      @keyframes d6-ani {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.2);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .d7 {
      position: absolute;
      width: calc(85px*var(--beilv));
      top: calc(800px*var(--beilv));
      left: calc(655px*var(--beilv));
      animation: d5-ani 2s linear infinite;

      @keyframes d5-ani {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.2);
        }

        100% {
          transform: scale(1);
        }
      }
    }

    .tips {
      position: absolute;
      top: 80px;
      left: 50px;

      .icon1 {
        width: 60px;
      }

      width: 110px;
      font-size: 14px;
      text-align: center;

      .words {
        color: #000;
        text-shadow:
          -1px -1px 0 #fff,
          1px -1px 0 #fff,
          -1px 1px 0 #fff,
          1px 1px 0 #fff;
      }

    }

    .describe {
      background-color: #413f3fb9;
      position: fixed;
      width: 90px;
      height: 30px;
      right: 0;
      top: 90px;
      font-size: 16px;
      line-height: 30px;
      box-sizing: border-box;
      padding-left: 15px;
      color: #fff;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;

    }

    .describe-box {
      position: fixed;
      width: 100%;
      height: 100vh;
      background-color: #0000009e;
      z-index: 5;

      // overflow: hidden;
      .box {
        background: url("../static/step-box.png") no-repeat;
        background-size: 100% 100%;
        width: 320px;
        height: 500px;
        position: absolute;
        top: 80px;
        left: 50%;
        margin-left: -160px;
        box-sizing: border-box;
        padding: 45px 35px;
        font-size: 14px;
        text-align: justify;
        text-indent: 2em;
        line-height: 24px;
        color: #882727;
        font-weight: 800;
        text-shadow:
          -1px -1px 0 #f1f1f1,
          1px -1px 0 #f1f1f1,
          -1px 1px 0 #f1f1f1,
          1px 1px 0 #f1f1f1;
      }

      .close {
        font-size: 30px;
        position: absolute;
        top: 30px;
        right: 30px;
        color: #fff;
      }
    }

    .day-box {
      position: fixed;
      width: 100%;
      height: 100vh;
      background-color: #0000009e;
      z-index: 5;

      .theday-box {
        background: url("../static/day-box.jpg") no-repeat;
        background-size: 100% 100%;
        width: 320px;
        height: 560px;
        position: absolute;
        top: 60px;
        left: 50%;
        border-radius: 20px;
        margin-left: -160px;
        box-sizing: border-box;
        padding: 25px 25px;


        .theday {
          overflow: hidden;
          height: 510px;
          font-size: 15px;
          overflow-y: scroll;
            text-align: justify;
            line-height: 20px;
            color: #000;
            text-shadow:
              -1px -1px 0 #fff,
              1px -1px 0 #fff,
              -1px 1px 0 #fff,
              1px 1px 0 #fff;
            width: 100%;
          .thetitle {
     
            font-size: 30px;
            line-height: 35px;
            text-align: center;
            // margin-left: -15px;
            font-weight: 800;
            color: #da1f1f;
          }

          .time {
            margin-top: 10px;
          }

          .address {
            margin-top: 10px;
          }

          .introduce {
            text-indent: 2em;

          }

          .theimg {
            margin-top: 15px;
            border-radius: 20px;
            width: 100%;
            margin-bottom: 30px;
          }
        }

      }

      .close {
        font-size: 30px;
        position: absolute;
        top: 20px;
        right: 20px;
        color: #fff;
      }
    }
  }
}
</style>